import firebase from "@core/settings/firebase-settings";
import { LoginStore } from "@modules/authentication/pages/login/login.store";
import { useStore } from "@policoders/di";
import { Navigate } from "react-router-dom";

export const PrivateRoute = ({ element }: any) => {
  const store = useStore<LoginStore>("LoginStore");
  const isAuth = store.state.authenticated || firebase.auth.currentUser !== null;
  return !isAuth ? <Navigate to="/login" replace /> : element;
};
